import { render, staticRenderFns } from "./deviceTypeFilterElement.vue?vue&type=template&id=11854928&scoped=true"
import script from "./deviceTypeFilterElement.vue?vue&type=script&lang=js"
export * from "./deviceTypeFilterElement.vue?vue&type=script&lang=js"
import style0 from "./deviceTypeFilterElement.vue?vue&type=style&index=0&id=11854928&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11854928",
  null
  
)

export default component.exports